import { get } from 'lodash'

const state = {
  userPreferences: {
    tablesItemsPerPage: null,
    mapLabelsSelected: null,
    mapStyleSelected: null,
    assetListColumns: null,
    assetListDate: null,
    deadlineThreshold: null,
  },
}

const getters = {
  userPreferences: (state) => state.userPreferences,
  tablesItemsPerPage: (state) =>
    get(state, 'userPreferences.tablesItemsPerPage', null),
  mapLabelsSelected: (state) =>
    get(state, 'userPreferences.mapLabelsSelected', null),
  mapStyleSelected: (state) =>
    get(state, 'userPreferences.mapStyleSelected', null),
  assetListColumns: (state) =>
    get(state, 'userPreferences.assetListColumns', null),
  assetListDate: (state) => get(state, 'userPreferences.assetListDate', null),
  deadlineThreshold: (state) =>
    get(state, 'userPreferences.deadlineThreshold', null),
  thresholdByCustomer: (state) => (customerName) => {
    return get(state, `userPreferences.deadlineThreshold.${customerName}`, 60)
  },
}

const actions = {
  FETCH_USER_PREFERENCES: ({ commit }) => {
    let userPreferences = {
      tablesItemsPerPage: null,
      mapLabelsSelected: null,
      mapStyleSelected: null,
      assetListColumns: null,
      assetListDate: null,
      deadlineThreshold: null,
    }

    try {
      userPreferences = JSON.parse(localStorage.getItem('userPreferences'))
    } catch {
      // silent catch
    }

    commit('SET_USER_PREFERENCES', userPreferences)
  },

  UPDATE_USER_PREFERENCES: ({ commit }, userPreferences) => {
    localStorage.setItem('userPreferences', JSON.stringify(userPreferences))

    commit('SET_USER_PREFERENCES', userPreferences)
  },

  UPDATE_ITEMS_PER_PAGE_PREFERENCE: (
    { getters, dispatch },
    { itemsPerPage, routeName },
  ) => {
    const userPreferences = Object.assign({}, getters.userPreferences)
    let tablesItemsPerPage = Object.assign({}, getters.tablesItemsPerPage)

    tablesItemsPerPage[routeName] = itemsPerPage
    userPreferences.tablesItemsPerPage = tablesItemsPerPage

    dispatch('UPDATE_USER_PREFERENCES', userPreferences)
  },
  UPDATE_MAP_LABELS_SELECTED: (
    { getters, dispatch },
    { mapLabels, customer },
  ) => {
    const userPreferences = Object.assign({}, getters.userPreferences)
    let mapLabelsSelected = Object.assign({}, getters.mapLabelsSelected)

    mapLabelsSelected[customer] = mapLabels
    userPreferences.mapLabelsSelected = mapLabelsSelected

    dispatch('UPDATE_USER_PREFERENCES', userPreferences)
  },
  UPDATE_MAP_STYLE_SELECTED: (
    { getters, dispatch },
    { mapStyle, customer },
  ) => {
    const userPreferences = Object.assign({}, getters.userPreferences)
    let mapStyleSelected = Object.assign({}, getters.mapStyleSelected)

    mapStyleSelected[customer] = mapStyle
    userPreferences.mapStyleSelected = mapStyleSelected

    dispatch('UPDATE_USER_PREFERENCES', userPreferences)
  },
  UPDATE_ASSET_LIST_COLUMNS: (
    { getters, dispatch },
    { assetListColumns, customer },
  ) => {
    const userPreferences = Object.assign({}, getters.userPreferences)
    let oldAssetListColumns = Object.assign({}, getters.assetListColumns)

    oldAssetListColumns[customer] = assetListColumns
    userPreferences.assetListColumns = oldAssetListColumns
    dispatch('UPDATE_USER_PREFERENCES', userPreferences)
  },
  UPDATE_ASSET_LIST_REGLEMENTARY: (
    { getters, dispatch },
    { assetListDate, customer },
  ) => {
    const userPreferences = Object.assign({}, getters.userPreferences)
    let oldassetListDate = Object.assign({}, getters.assetListDate)

    oldassetListDate[customer] = assetListDate
    userPreferences.assetListDate = oldassetListDate
    dispatch('UPDATE_USER_PREFERENCES', userPreferences)
  },
  UPDATE_ASSET_LIST_REGLEMENTARY_DEADLINE: (
    { getters, dispatch },
    { deadlineThreshold, customer },
  ) => {
    const userPreferences = Object.assign({}, getters.userPreferences)
    let oldDeadlineThreshold = Object.assign({}, getters.deadlineThreshold)

    oldDeadlineThreshold[customer] = deadlineThreshold
    userPreferences.deadlineThreshold = oldDeadlineThreshold
    dispatch('UPDATE_USER_PREFERENCES', userPreferences)
  },
}

const mutations = {
  SET_USER_PREFERENCES: (state, userPreferences) => {
    state.userPreferences = userPreferences
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
